<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'public-link.data-protection-documentation-new'">
    </span>
  </div>
  <div class="common-modal__content-scroll-column">
    <div class="common-content-button-card__card-container"
      [ngClass]="{'common-content-button-card__card-container--separator': referenceDocument.documentationList.length > 0 && !referenceDocument.dataProtectionView}">
      <div class="common-content-button-card__card-header-block">
        <div class="common-content-button-card__header-text-container">
          <div class="common-content-button-card__header-inner-text-container">
            <i class="lf-icon-documentation common-icon__md common-icon__main"></i>
            <p class="common-content-button-card__header-text-title"
              [afTranslate]="referenceDocument.dataProtectionView ? 'public-link.reference-documents' : 'public-link.associated-documentation'"></p>
          </div>
        </div>
        <button class="common-button__icon-lg"
          (click)="addDocument()"
          pTooltip="{{'documentation-list.add-documents' | afTranslate}}"
          tooltipPosition="left">
          <i class="lf-icon-add-round common-icon__md"></i>
        </button>
      </div>
      @if(referenceDocument.documentationList.length > 0 || !referenceDocument.dataProtectionView){
        <div class="common-table-instance__body-container">
          <div class="common-table-header__container">
            <div class="common-table-body__inner-row w-[calc(100%-30px)]">
              <div class="common-table-cell__container w-[60px]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('common.type'| afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[320px]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('common.title'| afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[100px]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('common.author' | afTranslate)">
                </span-tooltip>
              </div>
               <div class="common-table-cell__container w-[180px]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('common.creation' | afTranslate)">
                </span-tooltip>
              </div>
            </div>
            <div class="common-table-cell__container w-[30px]"></div>
          </div>
          <div class="common-table-body__container">
            @for(document of referenceDocument.documentationList | afOrderBy:['name']:false; track $index){
              <div class="common-table-body__row">
                <div class="common-table-body__inner-row w-[calc(100%-30px)]"
                  (click)="launchActionDocument(document, 'download')">
                  <div class="common-table-cell__container w-[60px]">
                    <span [class]="'common-icon__md ' + (document.extension | extensionDocument:'md')"></span>
                  </div>
                  <div class="common-table-cell__container w-[320px]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="document.name">
                    </span-tooltip>
                  </div>
                  <div class="common-table-cell__container w-[100px]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="document.creator">
                    </span-tooltip>
                  </div>
                  <div class="common-table-cell__container w-[180px]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="document.creationDate | convertDate:'without-time'">
                    </span-tooltip>
                  </div>
                </div>
                <div class="common-table-cell__container w-[30px] common-table__menu-options">
                  <button class="common-button__icon-md-noborder"
                    (click)="launchActionDocument(document, 'delete')"
                    pTooltip="{{'common.remove' | afTranslate}}"
                    tooltipPosition="bottom">
                    <i class="lf-icon-trash common-icon__md"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    @if (referenceDocument.dataProtectionView && !referenceDocument.isEquality) {
      <div class="common-content-button-card__card-container"
        [ngClass]="{'common-content-button-card__card-container--separator': !referenceDocument.legalData?.length && referenceDocument.chargedLiteralDefault}">
        <div class="common-content-button-card__card-header-block">
          <div class="common-content-button-card__header-text-container">
            <div class="common-content-button-card__header-inner-text-container">
              <i class="lf-icon-legal-reference common-icon__md common-icon__main"></i>
              <p class="common-content-button-card__header-text-title"
                [afTranslate]="'channel-configuration.legal-info'"></p>
            </div>
          </div>
            @if(referenceDocument.legalData?.length){
              <div class="common-content-button-card__card-buttons-wrapper">
                <button-with-text-menu-arrow
                  [item]="{keyName: 'text'}"
                  [list]="referenceDocument.legalSelectedLanguages"
                  [selectedOption]="referenceDocument.additionalLanguageSelected"
                  (launchActionEmitter)="changeSelectedLanguage('legal', $event.option)">
                </button-with-text-menu-arrow>
                <button-with-menu-action [item]="referenceDocument.actionMenu"
                  [multiline]="1"
                  (launchActionEmitter)="selectOption('legal',$event.action)">
                </button-with-menu-action>
              </div>
            }@else{
            <!-- @if(referenceDocument.legalData?.length === 0 && referenceDocument.chargedLiteralDefault){ -->
              <button class="common-button__icon-lg"
                (click)="configureData('legal')"
                pTooltip="{{'reference-document-modal.add-aditional-information' | afTranslate}}"
                tooltipPosition="left">
                <i class="lf-icon-add-round common-icon__md"></i>
              </button>
            <!-- }@else { -->
            }
        </div>
        @if(referenceDocument.legalData?.length > 0){
          <div class="common-content-button-card__card-info-block">
            <p class="common-table-cell__title-text-label"
              [afTranslate]="'channel-configuration.legal-info-new'"></p>
            <div class="common-table-cell__information-text-label"
              [innerHTML]="referenceDocument.legalLanguageSelected?.textDescription"></div>
          </div>
        }
      </div>

    }
    <div class="common-content-button-card__card-container"
      [ngClass]="{'common-content-button-card__card-container--separator': referenceDocument.protectionData.length > 0 && !referenceDocument.dataProtectionView}">
      <div class="common-content-button-card__card-header-block">
        <div class="common-content-button-card__header-text-container">
          <div class="common-content-button-card__header-inner-text-container">
            <i class="lf-icon-shield common-icon__md common-icon__main"></i>
            <p class="common-content-button-card__header-text-title"
              [afTranslate]="'protection-data-modal.data-protection-information'">
            </p>
          </div>
        </div>
        @if(referenceDocument.protectionData.length){
          <div class="common-content-button-card__card-buttons-wrapper">
            <button-with-text-menu-arrow
              [item]="{keyName: 'text'}"
              [list]="referenceDocument.protectionSelectedLanguages"
              [selectedOption]="referenceDocument.protectionLanguageSelected"
              (launchActionEmitter)="changeSelectedLanguage('protection', $event.option)">
            </button-with-text-menu-arrow>
            <button-with-menu-action [item]="referenceDocument.actionMenu"
              [multiline]="1"
              (launchActionEmitter)="selectOption('protection',$event.action)">
            </button-with-menu-action>
          </div>
        }@else{
          <button class="common-button__icon-lg"
            (click)="configureData('protection')"
            pTooltip="{{'reference-document-modal.add-data-protection-information' | afTranslate}}"
            tooltipPosition="left">
            <i class="lf-icon-add-round common-icon__md"></i>
          </button>
        }
      </div>
      @if(referenceDocument.protectionData?.length){
        <div class="common-content-button-card__card-info-block">
          <p class="common-table-cell__title-text-label"
            [afTranslate]="'protection-data-modal.processing-personal-data'">
          </p>
          <div class="common-table-cell__information-text-label"
            [innerHTML]="referenceDocument.protectionLanguageSelected?.textDescription">
          </div>
        </div>
      }
    </div>
    <div class="common-content-button-card__card-container"
      [ngClass]="{'common-content-button-card__card-container--separator': referenceDocument.additionalData?.length > 0 && !referenceDocument.dataProtectionView}">
      <div class="common-content-button-card__card-header-block">
        <div class="common-content-button-card__header-text-container">
          <div class="common-content-button-card__header-inner-text-container">
            <i class="lf-icon-information common-icon__md common-icon__main"></i>
            <p class="common-content-button-card__header-text-title"
              [afTranslate]="'channel-configuration.additional-info'">
            </p>
          </div>
        </div>
        @if(referenceDocument.additionalData?.length === 0 && referenceDocument.chargedLiteralDefault){
          <button class="common-button__icon-lg"
            (click)="configureData('additional')"
            pTooltip="{{'reference-document-modal.add-aditional-information' | afTranslate}}"
            tooltipPosition="left">
            <i class="lf-icon-add-round common-icon__md"></i>
          </button>
        }@else {
          <div class="common-content-button-card__card-buttons-wrapper">
            <button-with-text-menu-arrow
              [item]="{keyName: 'text'}"
              [list]="referenceDocument.additionalSelectedLanguages"
              [selectedOption]="referenceDocument.additionalLanguageSelected"
              (launchActionEmitter)="changeSelectedLanguage('additional', $event.option)">
            </button-with-text-menu-arrow>
            <button-with-menu-action [item]="referenceDocument.actionMenu"
              [multiline]="1"
              (launchActionEmitter)="selectOption('additional',$event.action)">
            </button-with-menu-action>
          </div>
        }
      </div>
      @if(referenceDocument.additionalData?.length > 0){
        <div class="common-content-button-card__card-info-block">
          <p class="common-table-cell__title-text-label"
            [afTranslate]="'protection-data-modal.want-know'">
          </p>
          <div class="common-table-cell__information-text-label"
            [innerHTML]="referenceDocument.additionalLanguageSelected?.textDescription">
          </div>
        </div>
      }
    </div>
    @if(skin !== 'steel-blue' && !configuration.concept.isFront && configuration.concept.communicationChannel){
      <div class="common-content-button-card__card-container"
        [ngClass]="{'common-content-button-card__card-container--separator': referenceDocument.documentationList.length > 0 && !referenceDocument.dataProtectionView}">
        <div class="common-content-button-card__card-header-block">
          <div class="common-content-button-card__header-text-container">
            <div class="common-content-button-card__header-inner-text-container">
              <i class="lf-icon-configuration common-icon__md common-icon__main"></i>
              <p class="common-content-button-card__header-text-title"
                [afTranslate]="'form-configuration-modal.form-configuration'">
                _Configuración del formulario
              </p>
            </div>
          </div>
          @if(referenceDocument.fieldContainerConfigurated?.fields?.length){
            <div class="common-content-button-card__card-buttons-wrapper">
              @if (referenceDocument.formTranslatedLanguages?.length > 1) {
                <button-with-text-menu-arrow
                  [item]="{keyName: 'text'}"
                  [list]="referenceDocument.formTranslatedLanguages"
                  [selectedOption]="referenceDocument.formTranslatedLanguageSelected"
                  (launchActionEmitter)="changeFormTranslation($event.option)">
                </button-with-text-menu-arrow>
              }
              <button-with-menu-action
                [item]="referenceDocument.actionMenuForm"
                [multiline]="1"
                (configureMenuEmitter)="openActionMenu()"
                (launchActionEmitter)="selectOption('configuration',$event.action)">
              </button-with-menu-action>
            </div>
          }@else {
            <button class="common-button__icon-lg"
              (click)="configureAdditionalGroup()"
              pTooltip="{{'anti-money-laundering-onboarding.configure' | afTranslate}}"
              tooltipPosition="left">
              <i class="lf-icon-add-round common-icon__md"></i>
            </button>
          }
        </div>
        @if(referenceDocument.fieldContainerConfigurated?.fields?.length){
          <div class="reference-document-modal__configurated-container">
            <p class="reference-document-modal__configurated-text"
              [afTranslate]="'reference-document-modal.info-form-configuration'">
              _Se ha personalizado el formulario añadiendo los siguientes campos:
            </p>
          </div>
          <div class="common-content-button-card__configurated-fields-block">
            <div class="common-tag__neutral-light">
              <span class="common-tag__neutral-label-text">{{referenceDocument.fieldContainerConfiguratedTranslation.name}}</span>
            </div>
            @for (field of referenceDocument.fieldContainerConfiguratedTranslation?.fields; track $index) {
              <field-item class="reference-document-modal__field-item"
                [fieldInfo]="field"
                [concept]="configuration.concept"
                [evaluationId]="referenceDocument.evaluationId"
                [viewMode]="true"
                [fieldContainer]="referenceDocument.fieldContainerConfigurated">
              </field-item>
            }
          </div>
        }
      </div>
    }
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleAccept()">
      <span class="common-button__text-title"
        [afTranslate]="'common.finish'">
      </span>
    </button>
  </div>
</div>
